import { useEffect, useState } from "react";
import { Trophy, Handshake } from "lucide-react";
import { api } from "@/lib/api";

const STYLE = { saskia: "from-rose-500 to-pink-400", stefan: "from-slate-800 to-rose-700" };
const monthName = (m) => new Date(`${m}-01T12:00:00`).toLocaleDateString("de-DE", { month: "long", year: "numeric" });

export function TeamHall() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/team/hall").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <section className="space-y-3" data-testid="team-hall">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <div><h2 className="font-display text-2xl font-extrabold flex items-center gap-2"><Trophy className="w-6 h-6 text-amber-500" /> Hall of Fame</h2><p className="text-sm text-slate-500">Alle Monatssieger im Pokal-Schrank.</p></div>
        <div className="flex gap-2 text-xs font-extrabold" data-testid="team-hall-wins">
          {Object.entries(d.names).map(([t, n]) => <span key={t} className={`px-3 h-8 rounded-full bg-gradient-to-r ${STYLE[t]} text-white inline-flex items-center gap-1`} data-testid={`team-hall-wins-${t}`}><Trophy className="w-3.5 h-3.5" /> {n}: {d.wins[t]}</span>)}
        </div>
      </div>
      {d.months.length === 0 ? (
        <div className="rounded-3xl border border-dashed border-amber-300 bg-amber-50/50 p-6 text-center text-sm text-slate-500" data-testid="team-hall-empty">Der Pokal-Schrank ist noch leer – der erste Monatssieger kommt am Monatsende hier rein!</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {d.months.map((m, i) => (
            <div key={m.month} className="rounded-3xl bg-white border border-amber-200 p-4 text-center fade-up" style={{ animationDelay: `${i * 50}ms` }} data-testid={`team-hall-${m.month}`}>
              <span className={`mx-auto w-14 h-14 rounded-full flex items-center justify-center shadow-lg ${m.winner ? "vip-gold-metal win-glow" : "bg-slate-100 text-slate-500"}`}>{m.winner ? <Trophy className="w-7 h-7" /> : <Handshake className="w-7 h-7" />}</span>
              <p className="text-xs font-bold text-slate-500 mt-2 capitalize">{monthName(m.month)}</p>
              <p className={`font-display font-extrabold mt-0.5 ${m.winner ? "bg-gradient-to-r bg-clip-text text-transparent " + STYLE[m.winner] : "text-slate-600"}`}>{m.winner ? d.names[m.winner] : "Unentschieden"}</p>
              <p className="text-[11px] text-slate-400 mt-1">{(m.points?.saskia || 0).toLocaleString("de-DE")} : {(m.points?.stefan || 0).toLocaleString("de-DE")}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
